import {configureStore} from '@reduxjs/toolkit';
import {useDispatch} from 'react-redux';
import rootReducer from "../reducer"
import {loadState, saveState} from "../utilities/LocalStorage";

const persistedState = loadState();

const store = configureStore({
  reducer: {
    rootReducer
  },
  preloadedState: persistedState
})

store.subscribe(() => {
  saveState(store.getState())
})

export type StateType = ReturnType<typeof store.getState>;

export type loginDispatch = typeof store.dispatch;

export function useStudentAuthDispatch() {
  return useDispatch<loginDispatch>()
}

export default store;